document.addEventListener('DOMContentLoaded', () => {

    function resetMenu() {
        document.querySelectorAll('.c-mobile-menu').forEach(function (item) {
            item.classList.remove('is-active')
        })
    }

    document.querySelectorAll('.js-mobile-menu-toggle').forEach(function (mobileMenuBtn) {
        mobileMenuBtn.addEventListener('click', function () {
            const mobileMenu = document.querySelector('.c-mobile-menu')
            const mobileMenuBackground = document.querySelector('.c-mobile-menu__overlay')
            const header = document.querySelector('.c-header')
            const toggle = document.querySelector('.c-header__toggle')
            const body = document.body;

            if (!mobileMenu.classList.contains('is-active')) {
                resetMenu()
                mobileMenu.classList.add('is-active')
                mobileMenuBackground.classList.add('is-active')
                header.classList.add('c-header--scroll')
                toggle.classList.add('is-active')
                body.classList.add('no-scroll')
                return
            }

            if (mobileMenu.classList.contains('is-active')) {
                mobileMenu.classList.remove('is-active')
                mobileMenuBackground.classList.remove('is-active')
                toggle.classList.remove('is-active')
                header.classList.remove('c-header--scroll')
                body.classList.remove('no-scroll')
            }

        })
    })


    const header = document.querySelector('.c-header')
    setHeaderScrollClass(header)

    window.addEventListener('scroll', function () {
        setHeaderScrollClass(header)
    })

    function setHeaderScrollClass(header) {
        if (window.scrollY > 0) {
            header.classList.add('c-header--scroll')
        }
        if (window.scrollY === 0) {
            header.classList.remove('c-header--scroll')
        }
    }

})
